import * as React from 'react';

const SvgXHightlighted = (props) => (
  <svg width={54} height={47} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M41.995 25.753c0 10.877-9.143 19.753-20.497 19.753C10.142 45.506 1 36.63 1 25.753S10.143 6 21.497 6c11.355 0 20.498 8.877 20.498 19.753Z"
      stroke="#585858"
      strokeWidth={2}
    />
    <path
      d="m27.993 21.044-1.597-1.541-5.009 4.905-5.009-4.905-1.597 1.541 5.082 4.836-5.082 4.835 1.597 1.542 5.01-4.905 5.008 4.905 1.597-1.542-5.081-4.835 5.081-4.836Z"
      fill="#585858"
    />
    <path
      d="m46.576 10.032.336-.432 1.128-2.352.096-.96h.336l.12.96L49.72 9.6l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V0h-3.072v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L43 5.016l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z"
      fill="#FF5E18"
    />
  </svg>
);

export default SvgXHightlighted;
